(function () {
	'use strict';
	$(document).ready(function () {

		function setCookie(cname, cvalue, exdays) {
			const d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			let expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		}

		function cookieExists(cname) {
			return document.cookie.includes(cname);
		}

		$('#js-ue-banner-close').on('click', function () {
			$('.ue-banner').slideUp(250, function () {
				$('.ue-banner').remove();
			});
			setCookie('uebannercookie', 'opened', 30);
		});

		function ueBannerClose() {
			$('.fhp-cookies .fhp-cookies-popup').removeClass('open').fadeOut();
			$('.fhp-cookies .fhp-cookies-bar').fadeOut();
			$('body').removeClass('fhp-no-scroll');
		}

		// Smooth scroll to
		$('.scroll-animation').on('click', function (e) {
			e.preventDefault();

			const href = $(this).attr('href');
			if (href) {
				$("html, body").animate({
					scrollTop: $(href).offset().top
				}, 1000);
			}
		});

		$('.scroll-animation a').on('click', function (e) {
			e.stopPropagation();
		});

		//Search trigger
		$('.search-trigger').click(function () {
			$(this).toggleClass('active');
			$('.search-panel').fadeToggle('active');
			return false;
		});

		//Clicked outside of element
		window.clickedOutside = function (targetToClose, callback, _excludes = []) {
			const excludes = Array.isArray(_excludes) ? _excludes : [_excludes];
			const $target = $(targetToClose);

			if (typeof callback !== "function") {
				console.error('Callback has to be a function!');
				return null;
			}

			$('body').on('click', function (e) {
				const clickedElement = e.target;
				const isTargetVisible = $target.css('display') !== 'none';
				const isClickedElementExcluded = excludes.some((exclusion) => $(exclusion).is(clickedElement) || !!$(exclusion).has(clickedElement).length);
				const isClickedElementTarget = $target.is(clickedElement);
				const isClickedElementATargetChild = $target.has(clickedElement).length === 0;

				if (
					isTargetVisible &&
					!isClickedElementExcluded &&
					!isClickedElementTarget &&
					isClickedElementATargetChild
				) {
					callback($target, excludes);
				}
			});
		}

		clickedOutside('.search-panel', function () {
			$('.search-trigger').removeClass('active');
			$('.search-panel').fadeOut();
		}, ['.search-trigger']);

		window?.['grecaptcha']?.ready(function () {
			const container = document.querySelector('.grecaptcha-badge');
			const iframe = container.querySelector('iframe');
			iframe.style.width = '300px';
			iframe.style.height = '150px';
			iframe.removeAttribute('frameborder');
			iframe.removeAttribute('scrolling');
			container.querySelector('.g-recaptcha-response').setAttribute('aria-hidden', 'true');
			container.querySelector('.g-recaptcha-response').setAttribute('title', 'Recaptcha response');
		});

		//File download modal
		$('.show-modal').on('click', function (e) {
			if (!cookieExists("filedownloadmodal")) {
				setCookie('filedownloadmodal', 'opened', 30);
				const modal = $('.file-download-modal');
				modal.fadeIn(function () {
					modal.find(".content").mCustomScrollbar({
						axis: "y",
						mouseWheel: {
							enable: true
						}
					});
				});
			}
		})

		function closeFileDownloadModal() {
			$('.file-download-modal').fadeOut();
		}

		$('.file-download-modal .modal-icon-close').on('click', closeFileDownloadModal)

		clickedOutside('.file-download-modal', closeFileDownloadModal, ['.show-modal']);
	});
}(jQuery));
